import './Shapes.css'

export function Circle({}) {

    return (
        <div class="loader">
            <svg viewBox="0 0 80 80">
                <circle 
                    id="test" 
                    cx="40" 
                    cy="40" 
                    r="32"
                    style={{
                        backgroundColor: "#fff"
                    }}
                >

                </circle>
            </svg>
        </div>
    );
}